<div data-cy="configure-loyalty-program-form">
  <app-loyalty-program-cashback-form
    *ngIf="isCashBack; else selectedPoints"
    [formGroup]="cashBackForm"
  ></app-loyalty-program-cashback-form>
  <ng-template #selectedPoints>
    <app-loyalty-program-points-form [formGroup]="pointsForm"></app-loyalty-program-points-form>
  </ng-template>
</div>
